import React from 'react';

export const GroupMixin = {

  //@@viewOn:mixins
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    UU5_Forms_GroupMixin: {
      classNames: {
        main: 'uu5-forms-group'
      }
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    value: React.PropTypes.arrayOf(
      React.PropTypes.shape({
        label: React.PropTypes.any.isRequired,
        name: React.PropTypes.string,
        value: React.PropTypes.bool,
        disabled: React.PropTypes.bool,
        hidden: React.PropTypes.bool
      })
    ),
    required: React.PropTypes.bool,
    requiredMessage: React.PropTypes.any,
    glyphicon: React.PropTypes.string,
    labelPosition: React.PropTypes.oneOf(['left', 'right']),
    inline: React.PropTypes.bool

  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      value: [],
      required: false,
      requiredMessage: 'Choose at least one option.',
      glyphicon: 'uu-glyphicon-ok',
      inline: false,
      labelPosition: 'right'
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  isValid: function () {
    var feedback = this.getFeedback();
    var value = this.getValue();
    var result = true;

    if (this.props.required && (value === null || value.length < 1)) {
      this.setError(this.props.requiredMessage);
      result = false;
    } else if (feedback === 'error') {
      result = false;
    } else if (typeof this.isValid_ === 'function') {
      result = this.isValid_();
    }

    if (result && this.props.onValidate) {
      var validation = this.props.onValidate(value, this);
      if (validation && typeof validation === 'object') {
        if (validation.feedback === 'error') {
          result = false;
        }
      }
    }

    return result;
  },
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  //@@viewOff:render
};

export default GroupMixin;



// WEBPACK FOOTER //
// ./forms/mixins/group-mixin.js